import TelaModel from "@/models/telaModel";
import TelaService from "@/services/telaService";
import { AcaoController, DescricaoTela } from "@/utils/common/permissionConstants";

export type MenuItem = {
    id: string;
    name: string;
    title: string;
    description: string;
    classIcon: string;
    itens: Array<SubMenuItem>;
};

export type SubMenuItem = {
    id: string;
    name: string;
    title: string;
    listRoute: string;
    editRoute: string;
    editRouteLocked: boolean;
    itens: Array<SubMenuItem>;
    link: string;
};

type LoadMenusProps = {
    VALIDAR_PERMISSAO_USUARIO: (telaDescricao: string, acaoController: string) => boolean;
    franquiaId: number;
    isEstereis: boolean;
    isEstereisOuFracionamento: boolean;
    bloquearCadastroDeProduto: boolean;
};

function isEditRouteLocked(
    telaDescricao: string,
    isEstereisOuFracionamento: boolean,
    VALIDAR_PERMISSAO_USUARIO: LoadMenusProps["VALIDAR_PERMISSAO_USUARIO"],
) {
    return (
        telaDescricao == DescricaoTela.formulasPadrao &&
        isEstereisOuFracionamento &&
        !VALIDAR_PERMISSAO_USUARIO(telaDescricao, AcaoController.edicaoFormulaPadrao)
    );
}

export default async function loadMenus({
    VALIDAR_PERMISSAO_USUARIO,
    franquiaId,
    isEstereis,
    isEstereisOuFracionamento,
    bloquearCadastroDeProduto,
}: LoadMenusProps) {
    const menus = new TelaModel();
    menus.filhos = new Array<TelaModel>();

    try {
        const telasMenu = await new TelaService().getMenu().withLoading().resolveWithJSON<TelaModel[]>();

        let count = 0;
        let countAux = 0;
        const navMenuItens: MenuItem[] = [];

        for (const menu of telasMenu) {
            navMenuItens.push({
                id: menu.id.toString(),
                name: menu.id.toString(),
                title: menu.descricao,
                description: menu.subtitle,
                classIcon: menu.iconeMenu,
                itens: [],
            });

            if (menu.filhos != null) {
                for (const subMenu of menu.filhos) {
                    if (subMenu.descricao == "pcp_industria" && !isEstereis) {
                        continue;
                    }

                    if (subMenu.descricao == "venda_suppet" && !isEstereis) {
                        continue;
                    }

                    if (subMenu.descricao == "produtos" && bloquearCadastroDeProduto) {
                        subMenu.iconeAcaoRapida = undefined;
                        subMenu.rotaAcaoRapida = undefined;
                    }

                    navMenuItens[count].itens.push({
                        id: subMenu.descricao + menu.id.toString(),
                        name: subMenu.id.toString(),
                        title: subMenu.descricao,
                        listRoute: subMenu.rota,
                        editRoute: VALIDAR_PERMISSAO_USUARIO(subMenu.descricao, "insert")
                            ? subMenu.rotaAcaoRapida
                            : null,
                        editRouteLocked: isEditRouteLocked(
                            subMenu.descricao,
                            isEstereisOuFracionamento,
                            VALIDAR_PERMISSAO_USUARIO,
                        ),
                        itens: [],
                        link: subMenu.link,
                    });

                    if (subMenu.filhos != null) {
                        for (const subSubMenu of subMenu.filhos) {
                            if (subSubMenu.descricao == "pre_venda" && franquiaId != 109) {
                                continue;
                            }

                            // Mesma regra da Venda Suppet, que aplica as faixas de desconto da franquia.
                            if (subSubMenu.descricao == "desconto_b2b" && !isEstereis) {
                                continue;
                            }

                            navMenuItens[count].itens[countAux].itens.push({
                                id: menu.id.toString() + subMenu.id.toString() + subSubMenu.id.toString(),
                                name: subSubMenu.id.toString(),
                                title: subSubMenu.descricao,
                                listRoute: subSubMenu.rota,
                                editRoute: VALIDAR_PERMISSAO_USUARIO(subSubMenu.descricao, "insert")
                                    ? subSubMenu.rotaAcaoRapida
                                    : null,
                                editRouteLocked: isEditRouteLocked(
                                    subSubMenu.descricao,
                                    isEstereisOuFracionamento,
                                    VALIDAR_PERMISSAO_USUARIO,
                                ),
                                itens: [],
                                link: subMenu.link,
                            });
                        }
                        countAux++;
                    }
                }
                countAux = 0;
            }
            count++;
        }

        return navMenuItens;
    } catch {}

    return [];
}
